import { useCallback, useEffect, useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";
import ProbationCircle from "../../assets/images/probationCircle.svg";
import FullTimeCircle from "../../assets/images/fullTimeCircle.svg";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import moment from "moment";
import { leaveDuration } from "../../data";
import Select from "react-select";
import LeaveHistoryService from "../../services/leaveHistory.service";

const LeaveRequestFilterModal = ({
  details,
  setDetails,
  tabIndex,
  handleFilter,
  clearFilter,
  date,
  setDate,
  checked,
  handleCheckedChange
}) => {
  const { filterBy, employees } = useStateContext();

  const [empOption, setEmpOption] = useState({});
  const [leaveCat, setLeaveCat] = useState([]);

  const currentDate = new Date();

  const fetchLeaveTypes = useCallback(() => {
    LeaveHistoryService.getLeaveCategory()
      .then((response) => {
        if (response.data) {
          const x = response.data.map((item) => ({
            label: item.catname,
            value: item.catid,
          }));
          setLeaveCat(x);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchLeaveTypes();
  }, [fetchLeaveTypes]);

  useEffect(() => {
    const filteredEmployees = employees.map((item) => ({
      label: item.name,
      value: item.empId,
    }));
    setEmpOption(filteredEmployees);
  }, [employees]);

  // const currentDate = new Date();

  const handleSelectChange = (e, type) => {
    // console.log(e.value);
    if (type === "empId") {
      setDetails((prev) => ({
        ...prev,
        empId: e.value,
      }));
    } else if (type === "leaveReason") {
      setDetails((prev) => ({
        ...prev,
        leaveReason: e.label,
      }));
    } else if (type === "leaveDays") {
      setDetails((prev) => ({
        ...prev,
        leaveDays: e.value,
      }));
    }
  };

  const handleChange = (e) => {
    setDate(e.value);
    setDetails({
      ...details,
      date: moment(new Date(e.value)).format("DD-MM-YYYY"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  return (
    <>
      <div
        className={`${
          filterBy ? "filterByModal visible" : "filterByModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Filter</span>
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Employee Name
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={empOption}
                onChange={(e) => {
                  handleSelectChange(e, "empId");
                }}
                value={
                  Array.isArray(empOption)
                    ? empOption.filter(
                        (option) => option.value === details.empId
                      )
                    : null
                }
              />
            </div>
            {/* <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Leave Reason
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={leaveCat}
                onChange={(e) => {
                  handleSelectChange(e, "leaveReason");
                }}
                value={
                  Array.isArray(leaveCat)
                    ? leaveCat.filter(
                        (option) => option.label === details.leaveReason
                      )
                    : null
                }
              />
            </div> */}
            <div className="mb-3 calendar-relative">
              <label htmlFor="leaveType" className="form-label">
                Apply Date
              </label>
              <Calendar
                value={date}
                onChange={handleChange}
                view="date"
                dateFormat="dd, MM, yy"
                style={{ width: "100%", height: "45px" }}
                showIcon
                maxDate={currentDate}
                selectOtherMonths
              />
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Leave Days
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={leaveDuration}
                onChange={(e) => {
                  handleSelectChange(e, "leaveDays");
                }}
                value={
                  Array.isArray(leaveDuration)
                    ? leaveDuration.filter(
                        (option) => option.value === details.leaveDays
                      )
                    : null
                }
              />
            </div>
            <div className="mb-3">
              <div className="statusFilter-flex2">
                <div className="sort-flex">
                  <div className="">
                    <img src={ProbationCircle} alt="" />
                    <span className="status-filter">Probation</span>
                  </div>
                  <label className="radio-container">
                    <input
                      type="radio"
                      checked={checked === "1"}
                      onChange={handleCheckedChange("1")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="sort-flex">
                  <div className="">
                    <img src={FullTimeCircle} alt="" />
                    <span className="status-filter">Full Time</span>
                  </div>

                  <label className="radio-container">
                    <input
                      type="radio"
                      checked={checked === "0"}
                      onChange={handleCheckedChange("0")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-reset" onClick={clearFilter}>
              Reset
            </button>
            <button className="btn btn-apply" onClick={handleFilter}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveRequestFilterModal;
